var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        [
          !_vm.value
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handleSelectExcel }
                },
                [_vm._v("\n      " + _vm._s(_vm.btnUpload) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("input", {
            ref: "input",
            staticStyle: { display: "none" },
            attrs: { type: "file", accept: _vm.ACCEPT.excel },
            on: { change: _vm.handleFileChange }
          }),
          _vm._v(" "),
          _vm.value
            ? _c(
                "el-tag",
                {
                  attrs: { closable: "" },
                  on: { close: _vm.handleRemoveExcel }
                },
                [_vm._v("\n      " + _vm._s(_vm.value.name) + "\n    ")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.btnTemp
        ? _c(
            "el-button",
            {
              attrs: { type: "success", size: "small" },
              on: { click: _vm.handleDownloadTemp }
            },
            [_vm._v("\n    " + _vm._s(_vm.btnTemp) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.btnList
        ? _c(
            "el-button",
            {
              attrs: { type: "success", size: "small" },
              on: { click: _vm.handleDownloadList }
            },
            [_vm._v("\n    " + _vm._s(_vm.btnList) + "\n  ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-235c7e52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-235c7e52","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/YsForm/YsUploadCombo.vue
// module id = null
// module chunks = 